<template>
  <!-- ▼Main Container -->
  <div class="boss-main-container">
    <div class="grid-container fluid">
      <div
        v-if="informationFirst"
        data-test="information-first"
        class="grid-x grid-margin-x"
      >
        <div
          class="cell"
          v-html="informationFirst"
        />
      </div>
      <div class="grid-margin-x boss-bgcolor-white-gray padding-top-1">
        <div class="cell pega-notice-header">
          <img
            class="pega-icon-bell"
            src="@/assets/images/bell.png"
          >
          <span>お知らせ</span>
        </div>
        <section class="cell">
          <div
            v-if="isSelectionConfirmation"
            data-test="selection-confirmation"
            class="pega-notice-label pega-input"
            @click="onClick('phases_and_statuses', goSettingsSelection)"
          >
            （ご利用の前に）御社の[選考フェーズ・選考ステータス]をご確認ください。
          </div>
          <div
            v-if="isBeforePublishedConfirmation"
            data-test="before-published-confirmation"
            class="pega-notice-label pega-input"
            @click="onClick('before_publishing_checklist', goCheckList)"
          >
            （ご利用の前に）掲載前チェックリストをご確認ください
          </div>
          <div
            v-if="newEntryCount.total"
            data-test="new-entry-count"
            class="pega-notice-label pega-input"
            @click="onClick('', goApplicantTop)"
          >
            {{ newEntryCountText }}
          </div>
          <div
            v-if="showNewMessageCount"
            data-test="new-message-count"
            class="pega-notice-label pega-input"
            @click="onClick('', goApplicantTop)"
          >
            新しいメッセージが届きました。{{ newMessageCountText }}
          </div>
          <div
            v-if="isNewDtypeEntry"
            data-test="dtype-entry-link"
            class="pega-notice-label pega-input pega-notice"
            @click="goDtypeEntry()"
          >
            Direct typeに新しい応募・メッセージが届きました。Direct typeをご確認ください。
          </div>
          <div
            v-if="isSearchNewUsers"
            data-test="search-new-users"
            class="pega-notice-label pega-input"
            @click="onClick('updated_user_resume', goScoutTop)"
          >
            保存した検索条件に、新しい会員がヒットしました。スカウトやいいねを送ってみませんか
          </div>
          <div
            v-if="isRecommendedNewUsers"
            data-test="recommended-new-users"
            class="pega-notice-label pega-input hover"
            @click="onClick('new_recommended_users', goScoutTop)"
          >
            おすすめ会員が更新されました。スカウトやいいねを送ってみませんか
          </div>
        </section>
        <announcements
          v-if="!!announcements.length"
          :announcements="announcements"
        />
      </div>
      <div
        v-if="showScout"
        class="grid-x grid-margin-x"
      >
        <div class="width-100">
          <section class="boss-pickup-container">
            <scout-recommended-members />
          </section>
        </div>
      </div>
      <div
        v-if="informationThird"
        data-test="information-third"
        class="grid-x grid-margin-x margin-top-1"
      >
        <div
          class="cell"
          v-html="informationThird"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Announcements from '@/components/molecules/Announcements.vue'
import ScoutRecommendedMembers from '@/components/organisms/ScoutRecommendedMembers'

export default {
  components: {
    ScoutRecommendedMembers,
    Announcements
  },
  data () {
    return {
      isSelectionConfirmation: false,
      isBeforePublishedConfirmation: false,
      newEntryCount: {
        total: 0,
        casualInterview: 0,
        entry: 0
      },
      newMessageCount: {
        selection: 0,
        entered: 0,
        ng: 0,
        decline: 0
      },
      isNewDtypeEntry: false,
      isSearchNewUsers: false,
      isRecommendedNewUsers: false,
      informationFirst: '',
      informationThird: '',
      announcements: []
    }
  },
  computed: {
    ...mapGetters('contracts', {
      publishedContracts: 'publishedContracts'
    }),
    ...mapGetters([
      'showScout',
      'showDtypeEntryLink'
    ]),
    newMessageCountText () {
      return (this.newMessageCount.selection !== 0 ? ('（選考中の応募者から：' + this.newMessageCount.selection + '件）') : '') +
      (this.newMessageCount.entered !== 0 ? ('（入社の応募者から：' + this.newMessageCount.entered + '件）') : '') +
      (this.newMessageCount.ng !== 0 ? ('（NGの応募者から：' + this.newMessageCount.ng + '件）') : '') +
      (this.newMessageCount.decline !== 0 ? ('（辞退の応募者から：' + this.newMessageCount.decline + '件）') : '')
    },
    showNewMessageCount () {
      return this.newMessageCountText.length !== 0
    },
    newEntryCountText () {
      return `新しい応募が${this.newEntryCount.total}件あります。` +
        (this.newEntryCount.entry !== 0 ? (`（選考応募：${this.newEntryCount.entry}件）`) : '') +
        (this.newEntryCount.casualInterview !== 0 ? (`（話を聞きたい応募：${this.newEntryCount.casualInterview}件）`) : '')
    },
    dtypeEntryUrl () {
      return process.env.DTYPE_DCS_ENDPOINT + '/entries'
    }
  },
  async created () {
    if (this.showScout) {
      this.storeContracts()
      this.storeScoutDisplayItems()
    }
    const confirmations = [
      { apiPath: 'phases_and_statuses', dataPath: 'isSelectionConfirmation' },
      { apiPath: 'before_publishing_checklist', dataPath: 'isBeforePublishedConfirmation' },
      { apiPath: 'new_entry_count', dataPath: 'newEntryCount' },
      { apiPath: 'new_entry_messages_count', dataPath: 'newMessageCount' },
      { apiPath: 'updated_user_resume', dataPath: 'isSearchNewUsers' },
      { apiPath: 'new_recommended_users', dataPath: 'isRecommendedNewUsers' }
    ]
    const contents = [
      { apiPath: 'bko_information_first', dataPath: 'informationFirst' },
      { apiPath: 'bko_information_third', dataPath: 'informationThird' }
    ]
    confirmations.forEach(confirmation => this.fetchUnconfirmedInformation(confirmation.apiPath, confirmation.dataPath))
    contents.forEach(content => this.fetchContentsInformation(content.apiPath, content.dataPath))
    await this.$store.dispatch('setIsEnabledDtype')
    this.showDtypeEntryLink && this.fetchDtypeEntryIsNew()
    this.fetchAnnouncements()
  },
  methods: {
    ...mapActions('contracts', [
      'storeContracts'
    ]),
    ...mapActions('settings', [
      'storeScoutDisplayItems'
    ]),
    fetchUnconfirmedInformation (apiPath, dataPath) {
      this.$http.secured.get(`/company/unconfirmed_information/${apiPath}`).then((response) => {
        this.$set(this, dataPath, response.data)
      })
    },
    fetchContentsInformation (apiPath, dataPath) {
      this.$http.secured.get(`/company/contents/${apiPath}`).then((response) => {
        this.$set(this, dataPath, response.data)
      })
    },
    fetchAnnouncements () {
      this.$http.secured.get('/company/announcements').then((response) => {
        this.$set(this, 'announcements', response.data)
      })
    },
    fetchDtypeEntryIsNew () {
      this.$http.secured.get('/dtype/entry/is_new').then((response) => {
        this.$set(this, 'isNewDtypeEntry', response.data)
      })
    },
    goScoutTop () {
      this.$router.push({ name: 'scoutTop' })
    },
    goApplicantTop () {
      this.$router.push({ name: 'applicantTop' })
    },
    goSettingsSelection () {
      this.$router.push({ name: 'settingSelections' })
    },
    goCheckList () {
      window.open('/help/guide/001.html', '_blank')
    },
    goDtypeEntry () {
      window.open(this.dtypeEntryUrl, '_blank')
    },
    onClick (apiPath, callback) {
      if (apiPath) {
        this.$http.secured.patch(`/company/unconfirmed_information/${apiPath}/_is_read`).then(() => {
          callback()
        })
      } else {
        callback()
      }
    }
  }
}
</script>
